import React from "react";
import { connect, useSelector } from "react-redux";
import { PageHeader } from "@ant-design/pro-components";
import { Layout, Breadcrumb, Card, Tabs } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import "moment/locale/pt-br";
import "reactjs-popup/dist/index.css";

import TopBar from "components/NavBar/TopBar";
import DrawerSider from "components/NavBar/DrawerSider";
import { LayoutTopSide } from "components/NavBar/styles";
import AllUsers from "./All";
import Role from "./Role";
import Group from "./Group";
import Unit from "./Unit";
import { checkPermissions } from "../../utils/permission";

function UserAndPermission({ user }) {
    const navigate = useNavigate();
    const location = useLocation();
    const permissionsFromUser = useSelector((state) => state.user.permissions);
    const company = useSelector((state) => state.user.company);

    // Read the active tab from URLSearchParams
    const urlParams = new URLSearchParams(location.search);
    const activeKey = urlParams.get("tab") || "1";

    const handleTabChange = (key) => {
        const newUrlParams = new URLSearchParams(location.search);
        newUrlParams.set("tab", key);

        navigate({
            pathname: location.pathname,
            search: newUrlParams.toString(),
        });
    };

    const routes = [
        {
            breadcrumbName: "Usuários e Permissões",
            href: "/usuarios-e-permissoes",
        },
    ];

    const unitTabItem = checkPermissions(
        permissionsFromUser,
        company,
        ['MANAGE_COMPANIES'],
        {
            key: "4",
            label: "Unidades",
            children: <Unit />,
        }
    );

    const tabItems = [
        { key: "1", label: "Usuários", children: <AllUsers /> },
        { key: "2", label: "Grupos", children: <Group /> },
        { key: "3", label: "Papéis", children: <Role /> },
        ...(unitTabItem ? [unitTabItem] : []),
    ];

    return (
        <LayoutTopSide>
            <TopBar />
            <Layout style={{ overflow: "hidden" }}>
                <DrawerSider />
                <Layout
                    style={{
                        padding: "0 24px 24px",
                        height: "100%",
                        overflowY: "auto",
                    }}
                >
                    <PageHeader
                        style={{ margin: "16px 0 5px 0" }}
                        title="Usuários e Permissões"
                        subTitle="Gerencie usuários, grupos, papéis e unidades da sua empresa."
                        breadcrumb={
                            <Breadcrumb>
                                {routes.map((a) =>
                                    a.hasOwnProperty("href") ? (
                                        <Breadcrumb.Item key={Math.random()}>
                                            <a href onClick={() => navigate(a.href)}>
                                                {a.breadcrumbName}
                                            </a>
                                        </Breadcrumb.Item>
                                    ) : (
                                        <Breadcrumb.Item>{a.breadcrumbName}</Breadcrumb.Item>
                                    )
                                )}
                            </Breadcrumb>
                        }
                    />
                    <Card>
                        <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={handleTabChange} items={tabItems} />
                    </Card>
                </Layout>
            </Layout>
        </LayoutTopSide>
    );
}

const mapStateToProps = ({ session }) => ({
    user: session.user,
});

export default connect(mapStateToProps)(UserAndPermission);
